import { useState, useEffect } from 'react';

import useSearchParams from '@Hooks/useSearchParams';

export interface UseSettingsResult {
  /** Дата для которой показываются баннеры, может меняться с помощью параметра в URL */
  now: Date;
}

function usePromoSettings(): UseSettingsResult {
  const [now, setNow] = useState(new Date());
  const searchParams = useSearchParams();

  // Устанавливаем текущее время через get-параметр, чтобы проверить правильность настройки периода
  useEffect(() => {
    const currentDate = searchParams.get('__current-date');
    const newNow: Date | string = currentDate ? new Date(currentDate) : null;

    if (!currentDate) return;
    if (newNow.toString() === 'Invalid Date') {
      // eslint-disable-next-line autofix/no-console, no-console
      console.log('Неверный формат даты');
      return;
    }

    // eslint-disable-next-line autofix/no-console, no-console
    console.log(`Указанная дата: ${newNow}`);
    setNow(newNow);
  }, [searchParams]);

  return {
    now,
  };
}

export default usePromoSettings;
